import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {
  CreateContactFormFieldModel,
  CreateContactFormFieldValidityStatusesEnum,
} from '../../../../../../../../src/store/panels/contacts/createContactForm/createContactFormState';
import {Trans} from '../../../../../../../shared/helpers/src/internationalization/react';
import {Handler} from '../../../../../../../shared/helpers/src/react/reactHelpers';
import {InlineLinkButton} from '../../../../../../../shared/ui/src/components/buttons/inlineLinkButton';

/*
 * Props.
 */

interface CreateContactInformationFormFieldErrorProps {
  formField: CreateContactFormFieldModel;
  formFieldName?: ReactNode;
  openContactDetailsPopup: Handler;
}

/*
 * Style.
 */

const StyledErrorWrapperDiv = styled.div`
  margin-bottom: -4px;
`;

const StyledInlineLinkButton = styled(InlineLinkButton)`
  color: ${(p) => p.theme.palette.red.shade40};
  text-decoration: underline;

  &:hover {
    color: ${(p) => p.theme.palette.red.shade50};
  }
`;

/*
 * Component.
 */

export const CreateContactInformationFormFieldError: FC<CreateContactInformationFormFieldErrorProps> = (
  props,
) => {
  const {formField, formFieldName, openContactDetailsPopup} = props;

  switch (formField.validity) {
    case CreateContactFormFieldValidityStatusesEnum.DUPLICATE:
      return (
        <StyledErrorWrapperDiv>
          <Trans id="create-contact-form-email-validity-error-duplicate">
            {formFieldName} already taken by
          </Trans>{' '}
          <StyledInlineLinkButton onClick={openContactDetailsPopup}>
            <Trans id="create-contact-form-email-validity-error-duplicate-another-contact">
              another contact.
            </Trans>
          </StyledInlineLinkButton>
        </StyledErrorWrapperDiv>
      );
    case CreateContactFormFieldValidityStatusesEnum.DUPLICATE_SELF:
      return (
        <StyledErrorWrapperDiv>
          <Trans id="create-contact-form-email-validity-error-duplicate-self">
            {formFieldName} already added to contact.
          </Trans>
        </StyledErrorWrapperDiv>
      );
    case CreateContactFormFieldValidityStatusesEnum.INVALID:
      return (
        <StyledErrorWrapperDiv>
          <Trans id="create-contact-form-email-validity-error-invalid">Invalid {formFieldName}.</Trans>
        </StyledErrorWrapperDiv>
      );
    case CreateContactFormFieldValidityStatusesEnum.TO_BE_CHECKED:
    case CreateContactFormFieldValidityStatusesEnum.VALID:
    default:
      return null;
  }
};
